import React, { useEffect, useState } from "react";
import {
    FaUserClock,
    FaUserCheck,
    FaUserPlus,
} from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";

function SummaryCards({ summaryData, onClick }) {
    const [selectedId, setSelectedId] = useState(null);

    useEffect(() => {
        setSelectedId(null);
    }, [summaryData]);

    const total =
        (summaryData?.new || 0) +
        (summaryData?.assigned || 0) +
        (summaryData?.closed || 0);

    const getPercent = (count) => {
        if (!total) return "0%";
        return `${Math.round((count / total) * 100)}%`;
    };


    const complaintData = [
        {
            complaint: summaryData?.new || 0,
            label: "Pending",
            color: "text-black",
            percent: getPercent(summaryData?.new || 0),
            icon: <FaUserClock className="text-yellow-400" />,
            filter: 'P',
        },
        {
            complaint: summaryData?.closed || 0,
            label: "Resolved",
            color: "text-black",
            percent: getPercent(summaryData?.closed || 0),
            icon: <FaUserCheck className="text-green-400" />,
            filter: 'R',
        },
        {
            complaint: summaryData?.assigned || 0,
            label: "Assigned",
            color: "text-black",
            percent: getPercent(summaryData?.assigned || 0),
            icon: <FaUserPlus className="text-blue-400" />,
            filter: 'A',
        },
    ];

    return (
        <Wrapper>

            <ScrollCard
                style={{
                    scrollBehavior: "smooth",
                }}
            >
                {complaintData.map((item, index) => (
                    <Card $selected={selectedId === index} index={index} key={index} onClick={() => {
                        setSelectedId(index);
                        onClick(item.filter);
                    }
                    }>
                        <ValueRow>
                            {/* <Value color={item.color}>{item.complaint}</Value>
                            <div className="text-xs text-gray-500">{item.percent}</div> */}
                            <div className='flex flex-row'>
                                <Value color={item.color}>{item.complaint}</Value>
                                {item.percent &&
                                    // <Tooltip label={item.subLabel}>
                                    <span className="ml-1 mt-auto text-sm text-gray-600 align-middle mb-1">{"(" + item.percent + ")"}</span>
                                    // </Tooltip>
                                }
                            </div>
                        </ValueRow>
                        <Label>
                            {item.label}
                            <ArrowWrap className="arrow">
                                <Chevron />
                            </ArrowWrap>
                        </Label>
                    </Card>
                    // <Card key={index} onClick={() => onClick(item.filter)}>
                    //     <div >
                    //         <span className={`text-lg font-bold ${item.color}`}>
                    //             {item.complaint}
                    //         </span>
                    //         <Label>
                    //             {item.label}
                    //             {item.icon}
                    //         </Label>
                    //     </div>
                    // </Card>
                ))}
            </ScrollCard>
        </Wrapper>
    );
}
const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
// const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedid, index }) => selectedid === index ? "shadow-sm shadow-primary-color" : ""}`;
// const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
// const Value = tw.p`
//   text-xl sm:text-2xl font-bold  
//   ${({ color }) =>
//         color}
// `;

const Card = tw.div`
  group min-w-[200px]
  rounded-lg bg-white
  p-4 cursor-pointer
  border border-gray-100
  shadow-sm
  transition-all duration-200
  hover:shadow-md hover:border-gray-200
  ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;

const ValueRow = tw.div`
  flex items-baseline gap-1
`;

const Value = tw.div`
  text-2xl font-semibold text-gray-900
`;

const Label = tw.div`
  flex  mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
  flex items-center
  text-gray-300
  transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
  text-lg
  transform translate-x-0
  opacity-60
  group-hover:opacity-100
  group-hover:text-gray-500
  group-hover:translate-x-1
`;

export default SummaryCards;

